import { FC } from "react";

const AVATAR_GRADIENTS = [
  "linear-gradient(135deg, #1565c0, #42a5f5)",
  "linear-gradient(135deg, #6a1b9a, #ab47bc)",
  "linear-gradient(135deg, #00695c, #26a69a)",
  "linear-gradient(135deg, #c62828, #ef5350)",
  "linear-gradient(135deg, #e65100, #ff9800)",
  "linear-gradient(135deg, #558b2f, #8bc34a)",
  "linear-gradient(135deg, #4527a0, #7c4dff)",
  "linear-gradient(135deg, #00838f, #26c6da)",
];

export function getAvatarColor(id: number): string {
  return AVATAR_GRADIENTS[id % AVATAR_GRADIENTS.length];
}

export function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return (parts[0]?.[0] ?? "").toUpperCase();
}

interface UserAvatarProps {
  src?: string | null;
  name: string;
  id?: number;
  size?: number;
  showStatus?: boolean;
  isActive?: boolean;
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

const UserAvatar: FC<UserAvatarProps> = ({
  src,
  name,
  id = 0,
  size = 72,
  showStatus = false,
  isActive = false,
  selected = false,
  disabled = false,
  onClick,
}) => {
  const initials = getInitials(name);
  const ringColor = selected ? "#018752" : "rgba(0,0,0,0.15)";
  const ringWidth = 2;
  const gap = 3;
  const dotSize = Math.max(10, Math.round(size * 0.14));

  return (
    <div
      onClick={disabled ? undefined : onClick}
      style={{
        position: "relative",
        width: size,
        height: size,
        borderRadius: "50%",
        border: `${ringWidth}px solid ${ringColor}`,
        padding: gap,
        boxSizing: "border-box",
        cursor: onClick ? (disabled ? "not-allowed" : "pointer") : "default",
        opacity: disabled ? 0.45 : 1,
        transition: "border-color 0.15s",
        flexShrink: 0,
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          borderRadius: "50%",
          overflow: "hidden",
          background: src ? `url(${src}) center/cover no-repeat` : getAvatarColor(id),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {!src && (
          <span
            style={{
              color: "#fff",
              fontWeight: 700,
              fontSize: Math.round(size * 0.28),
              lineHeight: 1,
              userSelect: "none",
            }}
          >
            {initials}
          </span>
        )}
      </div>

      {showStatus && (
        <div
          style={{
            position: "absolute",
            bottom: ringWidth + 1,
            right: ringWidth + 1,
            width: dotSize,
            height: dotSize,
            borderRadius: "50%",
            background: isActive
              ? "linear-gradient(135deg, #22c55e, #16a34a)"
              : "#9ca3af",
            border: "2.5px solid #fff",
            boxSizing: "border-box",
            boxShadow: isActive ? "0 0 0 2px rgba(34,197,94,0.3)" : "none",
          }}
        />
      )}
    </div>
  );
};

export default UserAvatar;
